import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const card = css`
  width: 800px;
  max-width: 90%;
`;

export const collections = css`
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 1rem;
`;

export const logo = css`
  transition: transform 0.25s ease-in;
`;

export const collection = css`
  display: flex;
  flex: 1;
  gap: 0.75rem;
  cursor: pointer;
  align-items: center;
  border-radius: 4px;
  min-width: 100%;
  padding: 0.5rem;
  @media screen and (width > ${theme.sizes.screens.lg}) {
    min-width: calc(50% - 0.5rem);
    max-width: calc(50% - 0.5rem);
  }
  &:hover .${logo} {
    transform: scale(1.2);
  }
`;

export const collectionDetails = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const collectionTitle = css`
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 0.25rem;
`;

export const collectionContent = css`
  color: ${theme.colors.peoople['gris-medio-claro']};
  font-size: 16px;
  font-weight: 600;
`;

export const alreadyInCollection = css`
  color: ${theme.colors.peoople['azul-claro-medio']};
  font-size: 16px;
  font-weight: 600;
`;
